// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WPNn","largestCol":"styles_largestCol__2VcE9","smallestCol":"styles_smallestCol__wiIY-"};